/**
 * Skeleton de carga para la página de Cotizaciones.
 * Replica el efecto animate-pulse del Dashboard para consistencia visual.
 */
export function OpportunitiesSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div>
          <div className="h-7 w-36 bg-slate-200 rounded-md mb-2" />
          <div className="h-4 w-64 bg-slate-100 rounded" />
        </div>
      </div>

      {/* Metric cards skeleton - 4 tarjetas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="border border-slate-200 rounded-xl p-6 bg-white shadow-sm"
          >
            <div className="flex justify-between items-center">
              <div className="space-y-2 flex-1">
                <div className="h-3.5 w-24 bg-slate-200 rounded" />
                <div className="h-7 w-28 bg-slate-200 rounded" />
                <div className="h-3 w-20 bg-slate-100 rounded mt-1" />
              </div>
              <div className="h-8 w-8 bg-slate-100 rounded-lg" />
            </div>
          </div>
        ))}
      </div>

      {/* Tarjetas ganadas / perdidas skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Ganadas */}
        <div className="border border-green-100 rounded-xl p-4 bg-green-50/30">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 bg-green-100 rounded-xl" />
              <div className="space-y-2">
                <div className="h-3.5 w-28 bg-green-200/60 rounded" />
                <div className="h-5 w-20 bg-green-200/60 rounded" />
              </div>
            </div>
            <div className="h-8 w-28 bg-green-100 rounded-lg" />
          </div>
        </div>
        {/* Perdidas */}
        <div className="border border-red-100 rounded-xl p-4 bg-red-50/30">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 bg-red-100 rounded-xl" />
              <div className="space-y-2">
                <div className="h-3.5 w-28 bg-red-200/60 rounded" />
                <div className="h-5 w-20 bg-red-200/60 rounded" />
              </div>
            </div>
            <div className="h-8 w-24 bg-red-100 rounded-lg" />
          </div>
        </div>
      </div>

      {/* Kanban / tabla skeleton */}
      <div className="border border-slate-200 rounded-xl bg-white shadow-sm overflow-hidden">
        {/* Toolbar skeleton */}
        <div className="p-6 border-b border-slate-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 bg-blue-100 rounded-lg" />
              <div className="space-y-1.5">
                <div className="h-4 w-40 bg-slate-200 rounded" />
                <div className="h-3 w-52 bg-slate-100 rounded" />
              </div>
            </div>
            <div className="flex gap-2">
              <div className="h-8 w-32 bg-slate-900 rounded-md opacity-80" />
              <div className="h-8 w-20 bg-slate-100 rounded-md border border-slate-200" />
              <div className="h-8 w-20 bg-slate-100 rounded-md border border-slate-200" />
              <div className="h-8 w-8 bg-slate-100 rounded-md border border-slate-200" />
            </div>
          </div>
        </div>

        {/* Kanban columns skeleton */}
        <div className="p-6">
          <div className="flex gap-4 overflow-x-auto pb-2">
            {Array.from({ length: 4 }).map((_, colIdx) => (
              <div
                key={colIdx}
                className="flex-shrink-0 w-64 space-y-3"
              >
                {/* Column header */}
                <div className="flex items-center justify-between px-1">
                  <div className="flex items-center gap-2">
                    <div className="h-2.5 w-2.5 rounded-full bg-slate-300" />
                    <div className="h-3.5 w-20 bg-slate-200 rounded" />
                  </div>
                  <div className="h-5 w-5 bg-slate-100 rounded-full" />
                </div>
                {/* Cards */}
                {Array.from({ length: colIdx === 0 ? 3 : colIdx === 1 ? 2 : 1 }).map((_, cardIdx) => (
                  <div
                    key={cardIdx}
                    className="bg-slate-50 border border-slate-200 rounded-lg p-3 space-y-2"
                  >
                    <div className="h-3.5 w-4/5 bg-slate-200 rounded" />
                    <div className="h-3 w-3/5 bg-slate-100 rounded" />
                    <div className="flex justify-between items-center pt-1">
                      <div className="h-5 w-16 bg-slate-200 rounded" />
                      <div className="h-5 w-12 bg-slate-100 rounded-full" />
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
